module.exports = __webpack_public_path__ + "static/media/arrowRight.a0b91ed5.svg";